"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.75,0H2.24A.57.57,0,0,0,1.6.64V20.15a.57.57,0,0,0,.64.64H8.63l3.2,3.15A.24.24,0,0,0,12,24a.23.23,0,0,0,.16-.06l3.21-3.15h6.38a.57.57,0,0,0,.64-.64V.64A.56.56,0,0,0,21.75,0Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.56,6.93a3.42,3.42,0,0,0-2.22-.63H9.79v8h1.69V11.46h.73a3.51,3.51,0,0,0,2.3-.68,2.46,2.46,0,0,0,.81-2A2.3,2.3,0,0,0,14.56,6.93ZM13.21,9.76a1.84,1.84,0,0,1-1.17.31h-.56V7.69h.77a1.54,1.54,0,0,1,1,.29,1.13,1.13,0,0,1,.32.88A1.09,1.09,0,0,1,13.21,9.76Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.34,2.33H4.69a.55.55,0,0,0-.55.55V17.53a.55.55,0,0,0,.55.55H19.34a.55.55,0,0,0,.55-.55V2.88A.55.55,0,0,0,19.34,2.33ZM5.24,17V3.43H18.8V17Z",
    fill: "#fff"
  }));
};

exports["default"] = _default;